var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slds-nav-vertical__section"},[_c('h2',{staticClass:"slds-nav-vertical__title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("content"),(_vm.hasContentSlot === false)?_c('ul',[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }